"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBytes = exports.toBoolean = exports.toAddress = exports.toCoinAddrData = exports.toAddrData = exports.supportsCoinAddrData = exports.supportsAddrData = exports.toResolverData = void 0;
var stripHexPrefix = function (hex) { return hex.slice(2); };
// data encoders
var toResolverData = function (node) { return '0x0178b8bf' + stripHexPrefix(node); };
exports.toResolverData = toResolverData;
exports.supportsAddrData = '0x01ffc9a73b3b57de00000000000000000000000000000000000000000000000000000000';
exports.supportsCoinAddrData = '0x01ffc9a7f1cb7e0600000000000000000000000000000000000000000000000000000000';
var toAddrData = function (node) { return '0x3b3b57de' + stripHexPrefix(node); };
exports.toAddrData = toAddrData;
var toCoinAddrData = function (node, coinType) { return '0xf1cb7e06' + stripHexPrefix(node) + coinType.toString(16).padStart(64, '0'); };
exports.toCoinAddrData = toCoinAddrData;
// result decoders
var toAddress = function (result) { return '0x' + result.slice(-40); };
exports.toAddress = toAddress;
var toBoolean = function (result) { return (result !== '0x' && result !== '0x0000000000000000000000000000000000000000000000000000000000000000'); };
exports.toBoolean = toBoolean;
var toBytes = function (result) { return result.slice(130, 130 + parseInt(result.slice(66, 130), 16) * 2); };
exports.toBytes = toBytes;
//# sourceMappingURL=abi.js.map